import {MainLayout} from "../components/layouts/MainLayout.tsx";
import {Link} from "react-router-dom";
import UtilsHelper from "../helpers/utilsHelper.ts";

const TermsAndConditions = () => {
    UtilsHelper.changeWindowDocumentTitle("Regulamin");
    return (
        <MainLayout>
            <div className={"pt-4 max-w-5xl space-y-4"}>
                <h1 className={"text-2xl"}>Regulamin Usługi Beskid Media GO</h1>
                <div className={"w-28 rounded-full h-0.5 bg-[#008DD2]"}/>
                <p>Niniejszy regulamin określa zasady korzystania z usługi Beskid Media GO, oferującej streaming
                    telewizji online, świadczonej przez Beskid Media sp. z o.o.</p>

                <h2 className={"text-xl"}>1. Definicje</h2>
                <ul className={"list-disc list-inside"}>
                    <li><strong>Usługa</strong> – usługa Beskid Media GO, dodatkowa usługa umożliwiająca użytkownikom
                        dostęp do transmisji telewizyjnych na żywo poprzez internet. (dostępna dla klientów, którzy
                        posiadają dowolny pakiet usług telewizyjnych w Beskid Media)
                    </li>
                    <li><strong>Użytkownik</strong> - osoba fizyczna, która założyła konto w serwisie Beskid Media GO i
                        korzysta z jego funkcji zgodnie z niniejszym regulaminem.
                    </li>
                    <li><strong>Urządzenie</strong>:
                        <ul className={"pl-4"}>
                            <li>- komputery osobiste (stacjonarny lub laptop), wyposażone w system operacyjny Windows
                                (10 lub nowszy) lub Mac OS (12 Monterey lub nowszy) z zainstalowaną przeglądarką
                                internetową (w najnowszej wersji).
                            </li>
                            <li>- inne urządzenia przenośne typu smartfon lub tablet wyposażone w system operacyjny
                                Android (11 lub nowszy), iOS (15 lub nowszy), umożliwiający dostęp do sieci internetowej
                            </li>
                        </ul>
                    </li>
                </ul>

                <h2 className={"text-xl"}>2. Właściciel Usługi</h2>
                <p>Właścicielem usługi <strong>Beskid Media GO</strong> jest Beskid Media sp. z o.o. z siedzibą pod
                    adresem: ul. Tadeusza Kościuszki 115, 32-650 Kęty, wpisaną do rejestru przedsiębiorców Krajowego
                    Rejestru Sądowego prowadzonego przez Sąd Rejonowy dla Kraków-Śródmieście w Krakowie, XXII Wydział
                    Gospodarczy Krajowego Rejestru Sądowego, pod numerem KRS: 0000378167, NIP: 5492417339, REGON:
                    121463522.</p>

                <h2 className={"text-xl"}>3. Zasady Korzystania z Usługi</h2>
                <ul className={"list-disc list-inside"}>
                    <li>Usługa <strong>Beskid Media GO</strong> jest dostępna wyłącznie dla użytkowników znajdujących
                        się na terytorium Polski.
                    </li>
                    <li>Każdy użytkownik może być zalogowany maksymalnie na 5 urządzeniach, na których będzie mógł
                        korzystać z usługi. W przypadku próby przekroczenia limitu, zalogowanie na kolejnym urządzeniu
                        nie będzie możliwe.
                    </li>
                    <li>Użytkownik ma możliwość zarządzania zalogowanymi urządzeniami za pomocą portalu biura obsługi
                        klienta znajdującym się pod stroną internetową <a
                            className={"text-sky-500 hover:text-sky-600 transition-colors"}
                            href="https://bok.beskidmedia.pl/" target={"_blank"}>bok.beskidmedia.pl</a></li>
                    <li>Użytkownik jest zobowiązany do zapewnienia, że korzystanie z usługi odbywa się zgodnie z
                        obowiązującymi przepisami prawa oraz niniejszym regulaminem.
                    </li>
                </ul>

                <h2 className={"text-xl"}>4. Prawa Autorskie i Licencje</h2>
                <ul className={"list-disc list-inside"}>
                    <li>Wszystkie treści dostępne w ramach usługi <strong>Beskid Media GO</strong>, w tym transmisje
                        wideo, programy telewizyjne, grafiki oraz inne materiały audiowizualne, są chronione prawem
                        autorskim i stanowią własność ich odpowiednich właścicieli licencji.
                    </li>
                    <li>Użytkownikowi nie przysługuje prawo do kopiowania, udostępniania, publikowania ani
                        rozpowszechniania materiałów dostępnych w serwisie bez uprzedniej pisemnej zgody właścicieli
                        praw autorskich.
                    </li>
                    <li>Użytkowanie usługi w sposób naruszający prawa autorskie jest zabronione i może skutkować
                        natychmiastowym zablokowaniem konta użytkownika, a także podjęciem kroków prawnych przez
                        właścicieli praw.
                    </li>
                </ul>

                <h2 className={"text-xl"}>5. Ograniczenia Terytorialne</h2>
                <ul className={"list-disc list-inside"}>
                    <li>Usługa <strong>Beskid Media GO</strong> jest dostępna wyłącznie na terytorium Polski.
                        Korzystanie z serwisu poza granicami Polski jest technicznie ograniczone i nie jest możliwe.
                    </li>
                    <li>Ze względów licencyjnych, niektóre transmisje mogą być odtworzone tylko w wewnętrznej sieci
                        dostawcy usługi.
                    </li>
                </ul>
                <h2 className={"text-xl"}>6. Odpowiedzialność</h2>
                <ul className={"list-disc list-inside"}>
                    <li>Beskid Media sp. z o.o. nie ponosi odpowiedzialności za problemy techniczne, błędy transmisji
                        ani inne trudności wynikające z użytkowania serwisu, które są spowodowane działaniami
                        użytkownika, problemami z jego urządzeniami lub siecią internetową.
                    </li>
                    <li>Beskid Media sp. z o.o. zastrzega sobie prawo do przerwania świadczenia usługi w dowolnym
                        momencie z powodów technicznych lub w związku z aktualizacjami, bez wcześniejszego powiadomienia
                        użytkownika.
                    </li>
                </ul>

                <h2 className={"text-xl"}>7. Zgodność z Polityką Prywatności</h2>
                <p>Niniejszy regulamin jest zgodny z <Link
                    className={"text-sky-500 hover:text-sky-600 transition-colors"} to="/polityka-prywatnosci">Polityką
                    Prywatności</Link> Beskid Media sp. z o.o. Korzystanie z usługi Beskid Media GO oznacza akceptację
                    postanowień zarówno niniejszego regulaminu, jak i Polityki Prywatności, w której określono zasady
                    przetwarzania danych osobowych użytkowników oraz wykorzystania plików cookies.</p>
                <h2 className={"text-xl"}>8. Postanowienia Końcowe</h2>
                <ul className={"list-disc list-inside"}>
                    <li>Beskid Media sp. z o.o. zastrzega sobie prawo do zmiany niniejszego regulaminu w dowolnym
                        momencie. Wszelkie zmiany w regulaminie będą publikowane na stronie internetowej i wchodzą w
                        życie w momencie ich opublikowania.
                    </li>
                    <li>Korzystanie z usługi po wprowadzeniu zmian regulaminu oznacza akceptację wprowadzonych
                        modyfikacji.
                    </li>
                </ul>

                <p>Jeśli masz pytania dotyczące niniejszego regulaminu, prosimy o kontakt pod adresem: <a
                    href="mailto:kontakt@beskidmedia.pl">kontakt@beskidmedia.pl</a>.</p>

                <p><strong>Data publikacji:</strong> 01.10.2024r.</p>
            </div>
        </MainLayout>
    );
};

export default TermsAndConditions;